module.exports = __webpack_public_path__ + "static/img/two-piece-1.ab62908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/two-piece-1.jpg
// module id = /vOl
// module chunks = 1